export const USER_PAGE_SIZE = 60;

export const getUserLifecycleState = (user) => ({
  canToggleStatus: Boolean(user?.is_verified),
  isEffectivelyActive: Boolean(user?.is_verified && user?.is_active),
});

export const mergeMembershipOptions = (organizations, organizationIds, organizationNames) => {
  const options = [...organizations];
  const knownIds = new Set(options.map(({ id }) => id));

  organizationIds.forEach((id, index) => {
    if (!knownIds.has(id)) {
      options.push({ id, name: organizationNames[index] || id });
      knownIds.add(id);
    }
  });

  return options;
};
